import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalCloserService} from "../../modal-closer.service";

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  @Input()
  width:String;

  @Input()
  height:String;

  @Input()
  title:String;

  @Input()
  content;

  @Output()
  close = new EventEmitter();

  constructor(modalCloser:ModalCloserService) {
    modalCloser.closeEvents.subscribe((closeEvent) => this.close.emit(closeEvent));
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/Components/modal/modal.component.ts